import { useEffect } from 'react';
import { useState } from 'react';
import { GeoJSON } from 'ol/format.js';
import { ReactComponent as CloseMessage } from './images/close-message.svg';
import { ReactComponent as Minimize } from './images/minimize.svg';
import { Table, TableBody, TableCell, TableRow, Button } from '@mui/material';
import FolderIcon from '@mui/icons-material/Folder';
import FileModal from './FileModal';
import { useMediaQuery } from '@mui/material';

const InfoTable = ({ infoFeatures }) => {
  const [showTable, setShowTable] = useState(true);
  const [features, setFeatures] = useState();
  const [activeLayerId, setActiveLayerId] = useState('');
  const [documentsJSON, setDocumentsJSON] = useState('');
  const [minimizeTable, setMinimizeTable] = useState(false);
  const [open, setOpen] = useState(false);
  const isMobile = useMediaQuery('(max-width:600px)');

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (infoFeatures) {
      setShowTable(true);
      const features = new GeoJSON().readFeatures(infoFeatures);
      setFeatures(features);
      setActiveLayerId(infoFeatures.id);
      setDocumentsJSON(infoFeatures.properties?.dokumenti);
      delete infoFeatures.properties?.dokumenti;
    }
  }, [infoFeatures]);

  const toUpperCase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const checkIfNull = (str) => {
    return str ? str : '/';
  };

  return (
    <>
      {features && showTable && (
        <div
          style={{
            height: minimizeTable ? '' : '100svh',
            backgroundColor: minimizeTable ? '' : 'white',
          }}
        >
          <div className="element-info-config">
            <div className="element-info-title">
              <h3>{infoFeatures.id.replace(/\./g, ' ')}</h3>
            </div>
            <div className="header-right-side">
              <div
                className="header-button"
                onClick={() => setMinimizeTable((prev) => !prev)}
              >
                <Minimize style={{ width: '10px' }} />
              </div>
              <div
                className="header-button"
                onClick={() => {
                  setShowTable(false);
                }}
              >
                <CloseMessage style={{ height: '10px' }} />
              </div>
            </div>
          </div>
          {!minimizeTable && (
            <div className="element-info-table-position">
              <div style={{ height: '100%' }}>
                <Table className="element-info-head">
                  <TableBody>
                    {Object.entries(infoFeatures.properties).map(
                      ([key, value], index) => (
                        <TableRow key={index}>
                          <TableCell
                            style={{
                              marginRight: '10px',
                            }}
                            component="th"
                            scope="row"
                          >
                            {toUpperCase(key)}
                          </TableCell>
                          <TableCell
                            style={{ paddingLeft: '20px' }}
                            component="td"
                            scope="row"
                          >
                            {checkIfNull(value)}
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </div>
            </div>
          )}
          {!minimizeTable && (
            <div className="element-info-footer-config">
              <Button
                className="element-info-footer-button"
                sx={{ fontWeight: 600, fontSize: isMobile ? '10px' : '12px' }}
                color="primary"
                ariant="contained"
                tabIndex={-1}
                startIcon={<FolderIcon />}
                onClick={handleOpenModal}
              >
                Pogledaj Datoteke
              </Button>
              <FileModal
                open={open}
                activeLayerId={activeLayerId}
                documentsJSON={documentsJSON}
                handleClose={handleCloseModal}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default InfoTable;
